import { getStatusIconComponent } from '@/ui/composites/table';
import { Autorenew, DoDisturbOn } from '@/ui/primitives';
import type { ChipColorKey } from '@/ui';
import type { UploadDto, ResultsFileDto } from '@flowqa/shared';
import type { SvgIconComponent } from '@mui/icons-material';

// Upload-specific display helpers belong to the uploads feature.
const formatSnakeCaseLabel = (status: string): string =>
  status
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const formatUploadStatusLabel = (status: UploadDto['status']): string =>
  formatSnakeCaseLabel(status);

export const formatResultsFileStatusLabel = (status: ResultsFileDto['status']): string =>
  formatSnakeCaseLabel(status);

export const formatFileSizeKb = (bytes: number): string =>
  `${Math.max(1, Math.round(bytes / 1024))} KB`;

export const getUploadStatusChipColor = (status: UploadDto['status']): ChipColorKey => {
  if (status === 'completed') return 'green';
  if (status === 'completed_with_errors') return 'yellow';
  if (status === 'failed') return 'red';
  if (status === 'processing') return 'blue';
  return 'grey';
};

export const getUploadStatusIcon = (status: UploadDto['status']): SvgIconComponent => {
  if (status === 'completed') return getStatusIconComponent('passed');
  if (status === 'completed_with_errors') return getStatusIconComponent('errored');
  if (status === 'failed') return getStatusIconComponent('failed');
  if (status === 'processing') return Autorenew;
  return DoDisturbOn;
};

export const getResultsFileStatusIcon = (status: ResultsFileDto['status']): SvgIconComponent => {
  if (status === 'completed') return getStatusIconComponent('passed');
  if (status === 'failed') return getStatusIconComponent('failed');
  if (status === 'processing') return Autorenew;
  return DoDisturbOn;
};

export const getResultsFileStatusColor = (
  status: ResultsFileDto['status'],
): 'default' | 'blue' | 'green' | 'red' | 'orange' => {
  if (status === 'processing') return 'blue';
  if (status === 'completed') return 'green';
  if (status === 'failed') return 'red';
  return 'default';
};
